export default __webpack_public_path__ + "static/media/ball@3x.86965dcd.png";